import src from "IMAGE";
export default { src, width: 169, height: 34, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AJqamnJcXFxDT09POFFRUTtYWFhCUVFRP0VFRTRNTU07AKCgoHRTU1M+Xl5eRmRkZEtlZWVPaWlpU2ZmZkxdXV1H80IW1sDr6SsAAAAASUVORK5CYII="};
